module.exports = __webpack_public_path__ + "static/media/ecommerce.30f0e455.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeDo/ecommerce.svg
// module id = 329
// module chunks = 0